import React from 'react';
import PropTypes from 'prop-types';
import style from './EditableTableFieldNoOnBlurUpdate.module.css';

export const EditableTableFieldNoOnBlurUpdate = ({
  value,
  setValue,
  color,
  fontSize,
  inputType, 
  backgroundColor,
  disabled
}) => {
  return (
    <div className={style.div}>
      <input
        disabled={disabled}
        value={value}
        style={{ backgroundColor, color, fontSize }}
        type={inputType}
        className={style.input}
        onChange={({ target }) => setValue(target.value)}
        onClick={() => {
          if (value === 'Enter pattern...') setValue('');
        }}
      />
    </div>
  );
};

EditableTableFieldNoOnBlurUpdate.propTypes = {
  backgroundColor: PropTypes.any,
  color: PropTypes.any,
  fontSize: PropTypes.any,
  inputType: PropTypes.any,
  setValue: PropTypes.func,
  value: PropTypes.any,
  disabled: PropTypes.bool,
};



